export enum ExperienceType {
  PLOT = 0,
  STEALTH = 1
}
